import React, { useState } from "react";
import styled from "styled-components";
import { useTranslate } from '@tolgee/react';
import { ReactComponent as Chats } from "../../Assets/iconsv2/settings/chats.svg";
import { ReactComponent as Account } from "../../Assets/iconsv2/settings/account.svg";
import { ReactComponent as Contacts } from "../../Assets/iconsv2/settings/contacts.svg";
import { ReactComponent as Calls } from "../../Assets/iconsv2/settings/calls.svg";
import { ReactComponent as Appearance } from "../../Assets/iconsv2/settings/appearance.svg";
import { ReactComponent as Info } from "../../Assets/iconsv2/settings/info.svg";
import { ReactComponent as Logout } from "../../Assets/iconsv2/settings/logout.svg";
import { ReactComponent as Globe } from "../../Assets/iconsv2/sidebar/GlobeIcon.svg";
import { ReactComponent as MicIcon } from "../../Assets/iconsv2/settings/microphone.svg";
import SettingsElement from "./SettingsElement";
import {
  ACCOUNT,
  APPEARANCE,
  CALLS,
  CHATS,
  CONTACTS,
  HELP,
  INTERFACE_LANGUAGES,
  VOICE_CLONING,
} from "../../Constants/constantValues";
import { useAuthService } from "../../Context/AuthContext";
import packageJson from "../../../package.json";
import LocalStorage from "../../Helpers/LocalStorage";

const SettingsMenuList = ({ displayCategory, setDisplayCategory }) => {
  const appVersion = packageJson.version;
  const { signOutFirebase, handleSignOutUser } = useAuthService();

  const handleLogout = () => {
    if (LocalStorage.getSSOFlag() === "true") {
      handleSignOutUser();
    } else {
      signOutFirebase();
    }
  };
  const { t } = useTranslate();
  return (
    <SettingsMenuListContainer>
      <Header>
        <HeaderTitle>{t('general.settings')}</HeaderTitle>
      </Header>
      <Content>
        <Group>
          <GroupTitle>{t('general.account').toLocaleUpperCase()} </GroupTitle>

          <GroupContentWrapper>
            <SettingsElement
              text={t('general.account')}
              icon={<Account />}
              onClick={() => setDisplayCategory(ACCOUNT)}
              selected={displayCategory === ACCOUNT}
            />
            <SettingsElement
              text={t('settings.contacts')}
              icon={<Contacts />}
              onClick={() => setDisplayCategory(CONTACTS)}
              selected={displayCategory === CONTACTS}
            />
          </GroupContentWrapper>
        </Group>

        <Group>
          <GroupTitle>{t('settings.preferences').toUpperCase()} </GroupTitle>
          <GroupContentWrapper>
            <SettingsElement
              text={t('general.chats')}
              icon={<Chats />}
              onClick={() => setDisplayCategory(CHATS)}
              selected={displayCategory === CHATS}
            />
            <SettingsElement
              text={t('general.calls')}
              icon={<Calls />}
              onClick={() => setDisplayCategory(CALLS)}
              selected={displayCategory === CALLS}
            />
            <SettingsElement
              text={t('settings.appearance')}
              icon={<Appearance />}
              onClick={() => setDisplayCategory(APPEARANCE)}
              selected={displayCategory === APPEARANCE}
            />
            <SettingsElement
              text={t('voice_cloning.voice_preference')}
              icon={<MicIcon />}
              onClick={() => setDisplayCategory(VOICE_CLONING)}
              selected={displayCategory === VOICE_CLONING}
            />
            <SettingsElement
              text={t('general.interface_language')}
              icon={<Globe />}
              onClick={() => setDisplayCategory(INTERFACE_LANGUAGES)}
              selected={displayCategory === INTERFACE_LANGUAGES}
            />
          </GroupContentWrapper>
        </Group>
        <Group>
          <GroupTitle>{t('settings.info').toUpperCase()} </GroupTitle>
          <GroupContentWrapper>
            <SettingsElement
              text={t('settings.help')}
              icon={<Info />}
              onClick={() => setDisplayCategory(HELP)}
              selected={displayCategory === HELP}
            />
          </GroupContentWrapper>
        </Group>
        <Group>
          <GroupTitle>{t('settings.management')} </GroupTitle>
          <GroupContentWrapper>
            <SettingsElement
              text={t('profile.logout')}
              icon={<Logout />}
              reverse
              onClick={() => handleLogout()}
            />
          </GroupContentWrapper>
        </Group>
        <AppVersion>
          {t('profile.version')} {appVersion}
        </AppVersion>
      </Content>
    </SettingsMenuListContainer>
  );
};

export default SettingsMenuList;

const SettingsMenuListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  border-right: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  max-width: 420px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 23px 16px;
  align-items: center;
  background: ${({ theme }) => theme.menu.background};
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  gap: 20px;
`;
const HeaderTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.04px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  background: ${({ theme }) => theme.menu.background};
  height: 100%;
  overflow: auto;
`;
const GroupTitle = styled.p`
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.04px;
  vertical-align: middle;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
`;
const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const GroupContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
  overflow: hidden;
`;

const AppVersion = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.04px;
  vertical-align: middle;
  color: ${({ theme }) => theme.menu.version};
`;
